module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_1.5eb3060e.png";